
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSetupSaveDialog(
    $timeout, toastr, $filter, $location, $rootScope, NetworkListService, NetworkModel,
    EventServiceEvents, WorkstationListService, WorkstationListPOSTPaging, uuid, SnmpConfigurationService,
    PrinterListService, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/setup/setupSaveDialog/setupSaveDialog.template.html',
      link: function(scope) {



        const networkDefinition = angular.copy(scope.context.networkDefinition)
        scope.networkDefinition = networkDefinition
        scope.network = null;

        scope.saveComplete = false
        scope.dialogMessage = 'WorkingOnIt'

        function Stage () {
          this.start = null;
          this.end = null;
          this.abort = false;
          this.error = false;
        }

        function Task () {
          this.proccessStartTime = new Date().getTime()
          this.stagesCompleted = 0
          this.totalStages = null
          this.printerList = []
          this.snpm = null
          this.retryProxyAttempt = 0
          this.waitMessage = null
          this.messageInterval = null;
          this.stages = {}

          this.createStages = () => {

            this.stages.checkForProxy = new Stage()
            this.stages.startDiscovery = new Stage()
            this.stages.proccessDone = new Stage()
            this.totalStages = Object.keys(this.stages).length
          }

          this.stageStartTime = (stage) => {
            return this.stages[stage].start = new Date().getTime()
          };

          this.stageEndTime = (stage) => {
            return ((new Date().getTime() - this.stages[stage].start) / 1000).toFixed(2)
          }

          this.proccessEndTime = () => {
            return ((new Date().getTime() - this.proccessStartTime) / 1000).toFixed(2)
          }



          this.showDiscoverMessages = (showMessages) => {
            if (showMessages) {
              this.discoverMessages()
              this.messageInterval = setInterval(this.discoverMessages, 500);
            } else {
              clearInterval(this.messageInterval);
              this.discoverMessages()
            }
          }

          this.discoverMessages = () => {

            const timePassed = new Date().getTime() - this.stages.checkForProxy.start;
            const timeIncrement = 3000

            switch (this.printerList.length <= 0 ) {
              case (timePassed < timeIncrement):
                this.waitMessage = 'SetupWait1'
              break;
              case ((timePassed > timeIncrement) && (timePassed < (timeIncrement * 2))):
                this.waitMessage = 'SetupWait2'
              break;
              case ((timePassed > (timeIncrement * 2)) && (timePassed < (timeIncrement * 3))):
                this.waitMessage = 'SetupWait3'
              break;
              case ((timePassed > (timeIncrement * 3)) && (timePassed < (timeIncrement * 5))):
                this.waitMessage = 'SetupWait4'
              break;
              case ((timePassed > (timeIncrement * 5)) && (timePassed < (timeIncrement * 7))):
                this.waitMessage = 'SetupWait5'
              break;
              case (timePassed < (timeIncrement * 7)):
                this.waitMessage = 'SetupWait6'
              break;
              // default:
              //   this.waitMessage = null
              // break;
            }

            if  (this.printerList.length > 0 || this.stages.startDiscovery.end) {
              this.waitMessage = null;
            }

          }

          this.addPrinter = (printerURL) => {
            this.scrollElement = this.scrollElement ? this.scrollElement : document.querySelector(".pingResponseList")

            let that = this;
            PrinterListService.getPrinterByURL(printerURL).then(function(printer) {
              if ( that.printerList.length === 0) {
                that.showDiscoverMessages(false)
              }
              that.printerList.push(printer)

              $timeout(()=> {
                that.scrollElement.scrollTo( 0, that.scrollElement.scrollHeight )
              }, 100)
            }).catch(function(error){});
          }

        }

        scope.task = new Task();
        scope.task.createStages();

        (function(){
          $timeout(() => {
            getNetwork()
          }, 500)
        })()



        function getNetwork() {
          $http.get(scope.tenant.info._links['px:networks'].href + '?page0&pageSize=1&direction=ASC&sort=Name' ).then(function(networks) {
            if (scope.context.networkDefinition.name) {
              configureNetwork(networks.data._embedded['px:networkResources'][0])
            } else {
              scope.networkDefinition.network = scope.network = new NetworkModel(networks.data._embedded['px:networkResources'][0])
              checkForOnlineProxyComputer();
            }
          }).catch(function(error){});
        }

        function configureNetwork(network) {
          const url = network._links.self.href;
          const patch = [
            {
              op: 'replace',
              path: '/name',
              value: scope.context.networkDefinition.name,
            },
            {
              op: 'replace',
              path: '/clientMigratePrintQueues',
              value: true
            }];

          $http.patch(url, patch).then(function(networks) {
            scope.networkDefinition.network = scope.network = new NetworkModel(networks.data)
            checkForOnlineProxyComputer();
          }).catch(function(error){});
        }

        function revertNetwork () {
          const url = scope.network.info._links.self.href;
          const patch = [
            {
              op: 'replace',
              path: '/clientMigratePrintQueues',
              value: false
            }];

          $http.patch(url, patch).then(function(networks) {
            // scope.networkDefinition.network = scope.network = new NetworkModel(networks.data)
          }).catch(function(error){});
        }



        let retryCounter = 0;
        const retryDelayIncrement = [1000, 2000, 3000, 4000, 5000]

        function checkForOnlineProxyComputer () {
          if (retryCounter === 0) {
            scope.task.stages.checkForProxy.start = scope.task.stageStartTime('checkForProxy')
          }

          scope.task.showDiscoverMessages(true)
          let workstationListPaging = new WorkstationListPOSTPaging();
          workstationListPaging.pagingCriteria.networkFilters = [scope.network.info._links.self.href];
          workstationListPaging.pagingCriteria.active = true;

          WorkstationListService.postGetWorkstationListPaged(workstationListPaging).then(function(response) {
            if (response.list.length > 0) {
              scope.task.stages.checkForProxy.end = scope.task.stageEndTime('checkForProxy')
              getSnmpConfiguration();
              scope.task.stagesCompleted += 1;
            } else {
              $timeout(() => {
                if (retryCounter < retryDelayIncrement.length) {
                  scope.task.retryProxyAttempt = retryCounter;
                  retryCounter += 1;
                  checkForOnlineProxyComputer();
                } else {
                  scope.task.stages.proccessDone.end = scope.task.proccessEndTime()
                  scope.task.stages.checkForProxy.end = scope.task.stageEndTime('checkForProxy')
                  scope.task.stages.checkForProxy.abort = true;
                  scope.task.stages.checkForProxy.error = true;
                }
              }, retryDelayIncrement[retryCounter])
            }
          }).catch(function(error){
            scope.task.stages.checkForProxy.end = scope.task.stageEndTime('checkForProxy')
            scope.task.stages.checkForProxy.abort = true;
          });
        }

        function getSnmpConfiguration() {
          SnmpConfigurationService.getDefaultSnmpConfiguration().then(function (defaultSnmpConfiguration) {
            scope.task.stagesCompleted++;
            scope.task.snmp = defaultSnmpConfiguration;
            startDiscovery(defaultSnmpConfiguration);
          }).catch(function(error){
            scope.task.stages.gettingDefaultSnmpConfig.abort = true;
          });
        }


        function startDiscovery (defaultSnmpConfig) {
          scope.task.stages.startDiscovery.start = scope.task.stageStartTime('startDiscovery')

          scope.network.discoverNetwork(scope.network, defaultSnmpConfig).then(function(response) {

          }).catch(function(error){
            scope.task.stages.startDiscovery.end = scope.task.stageEndTime('startDiscovery')
            scope.task.stages.startDiscovery.abort = true
          });
        }

        scope.closeAndExit = function () {

          scope.callback()
        }

        let printer_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_ADDED, function(name, data) {
          if (data.network === scope.network.info._links.self.href) {
            scope.task.addPrinter(data.printer)
          }
        })

        let report_listener = $rootScope.$on(EventServiceEvents.CHANNELS.SPECIFIC_USER.EVENTS.DISCOVERY_REPORT, function(name, data) {
          scope.task.stages.startDiscovery.end = scope.task.stageEndTime('startDiscovery')
          scope.task.stages.proccessDone.end = scope.task.proccessEndTime()
          scope.task.stagesCompleted += 1;
          revertNetwork();
          $timeout(() => {
            toastr.success($filter("stringular")($filter("translate")("FoundPrinters"), scope.task.printerList.length))
          }, 2500)
        });

        scope.$on('$destroy', function() {
          if (scope.task.messageInterval) {
            clearInterval(scope.task.messageInterval)
          }

          printer_listener()
           report_listener()
        });

      }
    };
  }

  pxSetupSaveDialog.$inject = [
    '$timeout', 'toastr', '$filter', '$location', '$rootScope', 'NetworkListService', 'NetworkModel',
    'EventServiceEvents', 'WorkstationListService', 'WorkstationListPOSTPaging', 'uuid', 'SnmpConfigurationService',
    'PrinterListService', '$http'
  ];

  angular
    .module('printix-admin')
    .directive('pxSetupSaveDialog', pxSetupSaveDialog);

})();
